import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  deleteConfigCoupon,
  editConfigCoupon,
  getConfigCoupon,
  getExamListNew,
  getParentCourseNew,
  getSectionList,
  setParentCourse,
  uploadConfigCouponFile,
} from "../../../Action/courseAction";
import PageTitle from "../../../Module/pageTitle";
import LabelField from "../../../Component/labelField";
import AdminTable from "../../../Component/adminTable";
import { useSelector } from "react-redux";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AddMorebtn from "../../../Component/addMoreBtn";
import Dropdown from "../../../Component/dropdown";
import FormInputField from "../../../Component/FormInputField";
import SubmitButton from "../../../Component/SubmitButton";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import {
  pdf_size_150MB,
  pdf_size_1MB,
  validateIsFileImageType,
  validateIsFilePDFType,
} from "../../../Utils/validators";
import { showErrorSnackbar } from "../../../Action/snackbarAction";
import {
  validateIsFileImageTypeErrMsg,
  validateIsFilePDFTypeErrMsg,
} from "../../../Utils/errorMsg";

const activityTypeList = [
  { name: "Result", type: "result" },
  { name: "Faculty", type: "faculty" },
];

const StudentCouponEdit = () => {
  const dispatch = useDispatch();
  const initialValueSection = {
    sectionVal: "",
  };
  const initialValueActivity = {
    imagePreview: "",
    selectedImage: "",
    uploadedImage: "",
    textTwo: [""],
    textThree: [""],
    type: "",
  };
  const [state, setState] = useState({
    searchExam: "",
    searchExamStream: "",
    exam: "",
    examList: [],
    examStream: "",
    examStreamList: [],
    discount: "",
    durationHr: "",
    pdfLink: "",
    selectedPDF: "",
    uploadedPdf: "",
    messageId: "",
    editCouponId: "",
    couponList: [],
    sectionList: [],
    sectionData: [initialValueSection],
    morningImage: "",
    selectedMorningImage: "",
    uploadedMorningImage: "",
    morningURL: "",
    eveningImage: "",
    selectedEveningImage: "",
    uploadedEveningImage: "",
    eveningURL: "",
    activityData: [initialValueActivity],
  });

  const { isEditMode } = useSelector((state) => ({
    isEditMode: state.courseReducer?.isEditMode,
  }));

  const updateState = (key) => {
    setState((prevState) => ({
      ...prevState,
      ...key,
    }));
  };
  const onChangeSearchExam = (val) => {
    updateState({
      searchExam: val,
      searchExamStream: "",
      examStreamList: [],
    });
    if (val) {
      dispatch(
        getParentCourseNew(`${val._id}`, (res) => {
          updateState({ examStreamList: res });
        }),
      );
    }
  };
  const onChangeSearchExamStream = (val) => {
    updateState({ searchExamStream: val });
    fetchData(val?._id);
  };
  const changeSections = async (val, index) => {
    let newArray = JSON.parse(JSON.stringify(state?.sectionData));
    newArray[index].sectionVal = val;
    await updateState({ sectionData: newArray });
  };
  const handleLink = (link, val) => {
    val.preventDefault();
    window.open(link, "_blank");
  };
  const handlePDFChange = (e) => {
    e.preventDefault();
    if (!validateIsFilePDFType(e)) {
      dispatch(showErrorSnackbar(validateIsFilePDFTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > pdf_size_150MB) {
      dispatch(showErrorSnackbar("File size should be less than 150 MB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        updateState({
          pdfLink: reader.result,
          selectedPDF: file,
          uploadedImage: "",
        });
      };
      reader.readAsDataURL(file);
      dispatch(
        uploadConfigCouponFile(file, (res) => {
          if (res) updateState({ uploadedPdf: res?.fullPath });
          else updateState({ uploadedPdf: "" });
        }),
      );
    }
  };

  const onChangeMorningImage = (e) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > pdf_size_1MB) {
      dispatch(showErrorSnackbar("File size should be less than 1 MB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        updateState({
          morningImage: reader.result,
          selectedMorningImage: file,
        });
      };
      reader.readAsDataURL(file);
      dispatch(
        uploadConfigCouponFile(file, (res) => {
          if (res) updateState({ uploadedMorningImage: res?.fullPath });
          else updateState({ uploadedMorningImage: "" });
        }),
      );
    }
  };

  const onChangeMorningURL = (value) => {
    updateState({ morningURL: value });
  };

  const onChangeEveningURL = (value) => {
    updateState({ eveningURL: value });
  };

  const onChangeEveningImage = (e) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > pdf_size_1MB) {
      dispatch(showErrorSnackbar("File size should be less than 1 MB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        updateState({
          eveningImage: reader.result,
          selectedEveningImage: file,
        });
      };
      reader.readAsDataURL(file);
      dispatch(
        uploadConfigCouponFile(file, (res) => {
          if (res) updateState({ uploadedEveningImage: res?.fullPath });
          else updateState({ uploadedEveningImage: "" });
        }),
      );
    }
  };

  // ---------- User Activity handlers ----------

  const updateActivityAtIndex = (index, changes) => {
    setState((prevState) => ({
      ...prevState,
      activityData: (prevState?.activityData || []).map((item, i) =>
        i === index ? { ...item, ...changes } : item,
      ),
    }));
  };

  const onChangeActivityImage = (e, index) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      e.target.value = "";
      return;
    }

    if (file.size > pdf_size_1MB) {
      dispatch(showErrorSnackbar("File size should be less than 1 MB!"));
      e.target.value = "";
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      updateActivityAtIndex(index, {
        imagePreview: reader.result,
        selectedImage: file,
      });
    };
    reader.readAsDataURL(file);
    dispatch(
      uploadConfigCouponFile(file, (res) => {
        if (res?.fullPath) {
          updateActivityAtIndex(index, {
            uploadedImage: res.fullPath,
          });
        }
      }),
    );
  };

  const onChangeTextTwo = (activityIndex, textIndex, value) => {
    const newArray = (state?.activityData || []).map((item, i) => {
      if (i !== activityIndex) return item;
      const newTextTwo = [...item.textTwo];
      newTextTwo[textIndex] = value;
      return { ...item, textTwo: newTextTwo };
    });
    updateState({ activityData: newArray });
  };

  const addTextTwo = (activityIndex) => {
    const newArray = (state?.activityData || []).map((item, i) =>
      i === activityIndex ? { ...item, textTwo: [...item.textTwo, ""] } : item,
    );
    updateState({ activityData: newArray });
  };

  const removeTextTwo = (activityIndex, textIndex) => {
    const newArray = (state?.activityData || []).map((item, i) => {
      if (i !== activityIndex) return item;
      return {
        ...item,
        textTwo: item.textTwo.filter((_, idx) => idx !== textIndex),
      };
    });
    updateState({ activityData: newArray });
  };

  const onChangeTextThree = (activityIndex, textIndex, value) => {
    const newArray = (state?.activityData || []).map((item, i) => {
      if (i !== activityIndex) return item;
      const newTextThree = [...item.textThree];
      newTextThree[textIndex] = value;
      return { ...item, textThree: newTextThree };
    });
    updateState({ activityData: newArray });
  };

  const addTextThree = (activityIndex) => {
    const newArray = (state?.activityData || []).map((item, i) =>
      i === activityIndex
        ? { ...item, textThree: [...item.textThree, ""] }
        : item,
    );
    updateState({ activityData: newArray });
  };

  const removeTextThree = (activityIndex, textIndex) => {
    const newArray = (state?.activityData || []).map((item, i) => {
      if (i !== activityIndex) return item;
      return {
        ...item,
        textThree: item.textThree.filter((_, idx) => idx !== textIndex),
      };
    });
    updateState({ activityData: newArray });
  };

  const onChangeActivityType = (value, activityIndex) => {
    updateActivityAtIndex(activityIndex, { type: value });
  };

  const handleAddActivity = () => {
    updateState({
      activityData: [...(state?.activityData || []), initialValueActivity],
    });
  };

  const handleRemoveActivity = (index) => {
    const newArray = [...(state?.activityData || [])];
    newArray.splice(index, 1);
    updateState({ activityData: newArray });
  };
  // ---------- end User Activity handlers ----------

  const renderListMode = () => {
    const {
      examList,
      searchExam,
      examStreamList,
      searchExamStream,
      couponList,
    } = state;
    return (
      <>
        <div className="row g-2">
          <div className="d-flex align-items-center col-md-4 col-12">
            <LabelField labelName={"Exam Name"} />

            <Dropdown
              labelName="Select Exam Name"
              setInputText={(value) => onChangeSearchExam(value)}
              options={examList}
              value={searchExam}
              disabled={isEditMode}
            />
          </div>
          <div className="d-flex align-items-center col-md-4 col-12">
            <LabelField labelName={"Exam Stream"} />

            <Dropdown
              labelName="Select Exam Stream"
              setInputText={(value) => onChangeSearchExamStream(value)}
              options={examStreamList}
              value={searchExamStream}
              disabled={isEditMode}
            />
          </div>
        </div>
        <AdminTable
          tableData={couponList ? couponList : []}
          pagename={"coupon"}
          tableHead={[
            "S.N",
            "EXAM NAME",
            "EXAM STREAM",
            "IS ADMISSION",
            "DISCOUNT",
            "VALID UPTO",
            "PDF LINK",
            "MESSAGE TEMPLATE",
            "SECTION",
            "ACTION",
          ]}
          handleLink={(value, link) => handleLink(value, link)}
          handleEdit={(value) => handleEdit(value)}
          handleDelete={(value) => handleDelete(value)}
          edit={true}
        />
      </>
    );
  };
  const renderEditMode = () => {
    const {
      exam,
      examList,
      examStreamList,
      examStream,
      sectionData,
      sectionList,
      discount,
      durationHr,
      messageId,
      pdfLink,
      selectedPDF,
      morningImage,
      morningURL,
      eveningImage,
      eveningURL,
      activityData,
    } = state;
    return (
      <>
        <div className="col-md-6 col-12">
          <div className="d-flex align-items-center ">
            <LabelField labelName={"Exam Name"} />

            <Dropdown
              labelName="Select Exam Name"
              options={examList}
              value={exam}
              disabled={isEditMode}
            />
          </div>
          <div className="d-flex align-items-center ">
            <LabelField labelName={"Exam Stream"} />

            <Dropdown
              labelName="Select Exam Stream"
              options={examStreamList}
              value={examStream}
              disabled={isEditMode}
            />
          </div>
          {sectionData?.map((item, index) => {
            const { sectionVal } = item;
            return (
              <div className="d-flex align-items-center " key={index}>
                <LabelField
                  labelName={
                    sectionData?.length > 1 ? `Section ${index + 1}` : `Section`
                  }
                  isRequired={true}
                />

                <Dropdown
                  labelName="Select Exam Stream"
                  setInputText={(value) => changeSections(value, index)}
                  options={sectionList}
                  value={sectionVal}
                />
                <div>
                  {sectionData?.length === 1 ? null : (
                    <HighlightOffIcon
                      className="cursor ms-2"
                      color="primary"
                      fontSize="small"
                      onClick={() => handleCloseSection(index)}
                    />
                  )}
                </div>
              </div>
            );
          })}
          <div className="d-flex justify-content-end ">
            <AddMorebtn
              style={{
                width: "99px",
                height: "39px",
              }}
              handleClick={() =>
                updateState({
                  sectionData: [...sectionData, initialValueSection],
                })
              }
            />
          </div>
          <div className="d-flex align-items-center ">
            <LabelField labelName={"Discount Value"} isRequired={true} />

            <FormInputField
              placeholder={"Enter discount value"}
              setInputText={(value) => updateState({ discount: value })}
              value={discount}
            />
          </div>
          <div className="d-flex align-items-center ">
            <LabelField labelName={"Code Duration"} isRequired={true} />

            <FormInputField
              placeholder={"Enter Code Duration"}
              setInputText={(value) => updateState({ durationHr: value })}
              value={durationHr}
            />
          </div>
          <div className="d-flex align-items-center ">
            <LabelField labelName={"Message Template ID"} isRequired={true} />

            <FormInputField
              placeholder={"Enter message id"}
              setInputText={(value) => updateState({ messageId: value })}
              value={messageId}
            />
          </div>
        </div>
        <div className="col-md-6 col-12 d-flex align-items-center">
          <LabelField labelName={"PDF Url"} isRequired={true} />

          <ImagePickerAndViewer
            // labelName={"PDF Url"}
            value={pdfLink}
            handleChange={(e) => handlePDFChange(e)}
            htmlFor={"pdf-upload"}
            doctype={"pdf"}
            selectedPDF={selectedPDF}
            // isRequired={true}
          />
        </div>
        <div className="col-md-6 col-12 d-flex align-items-center">
          <LabelField labelName={"Morning Message"} />

          <div className="row flex-grow-1">
            <div className="col-md-3 col-12">
              <ImagePickerAndViewer
                value={morningImage}
                handleChange={(e) => onChangeMorningImage(e)}
                htmlFor={"morning-photo-upload"}
                removelabel={true}
              />
            </div>

            <div className="col-md-9 col-12 px-0">
              <FormInputField
                placeholder={"Enter Morning Url"}
                setInputText={(value) => onChangeMorningURL(value)}
                value={morningURL ? morningURL : ""}
                isMandatary={morningImage ? true : false}
                disabled={morningImage ? false : true}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6 col-12  d-flex align-items-center">
          <LabelField labelName={"Evening Message"} />
          <div className="row flex-grow-1">
            <div className="col-md-3 col-12">
              <ImagePickerAndViewer
                value={eveningImage}
                handleChange={(e) => onChangeEveningImage(e)}
                htmlFor={"evening-photo-upload"}
                removelabel={true}
              />
            </div>
            <div className="col-md-9 col-12 px-0">
              <FormInputField
                placeholder={"Enter Evening Url"}
                setInputText={(value) => onChangeEveningURL(value)}
                value={eveningURL ? eveningURL : ""}
                isMandatary={eveningImage ? true : false}
                disabled={eveningImage ? false : true}
              />
            </div>
          </div>
        </div>
        <div className="d-flex flex-wrap">
          <LabelField labelName={"User Activity"} />

          <div className="col-md-7 col-12">
            {activityData?.map((activity, activityIndex) => (
              <div
                key={activityIndex}
                className="border rounded p-3 mb-3 position-relative"
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="text-primary fw-bold  ">
                    {" "}
                    {activityIndex + 1}
                  </div>
                  {activityData.length > 1 && (
                    <HighlightOffIcon
                      className="cursor  "
                      style={{ right: 10, top: 10 }}
                      color="primary"
                      onClick={() => handleRemoveActivity(activityIndex)}
                    />
                  )}
                </div>

                {/* Image */}

                <div className="d-flex align-items-center mb-1">
                  <LabelField labelName={"Import Image"} isRequired={true} />

                  <ImagePickerAndViewer
                    key={activityIndex}
                    value={
                      activity.imagePreview || activity.uploadedImage || ""
                    }
                    handleChange={(e) =>
                      onChangeActivityImage(e, activityIndex)
                    }
                    htmlFor={`activity-image-${activityIndex}`}
                    isRequired={true}
                  />
                </div>

                {/* Text Two */}
                <div className="d-flex  align-items-center mb-1">
                  <LabelField labelName={"Text Two"} />
                  <div className="col-md-9">
                    {activity.textTwo.map((item, textIndex) => (
                      <div
                        className="d-flex align-items-center"
                        key={textIndex}
                      >
                        <div className="col-md-10">
                          <FormInputField
                            placeholder="Enter Text Two"
                            value={item}
                            setInputText={(value) =>
                              onChangeTextTwo(activityIndex, textIndex, value)
                            }
                          />
                        </div>

                        <div className="ms-2">
                          {activity.textTwo.length > 1 && (
                            <HighlightOffIcon
                              className="cursor"
                              color="primary"
                              onClick={() =>
                                removeTextTwo(activityIndex, textIndex)
                              }
                            />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <AddMorebtn
                    style={{
                      width: "100px",
                      height: "36px",
                    }}
                    handleClick={() => addTextTwo(activityIndex)}
                  />
                </div>

                {/* Text Three */}
                <div className="d-flex  align-items-center mb-1">
                  <LabelField labelName={"Text Three"} />
                  <div className="col-md-9">
                    {activity.textThree.map((item, textIndex) => (
                      <div
                        className="d-flex align-items-center "
                        key={textIndex}
                      >
                        <div className="col-md-10">
                          <FormInputField
                            placeholder="Enter Text Three"
                            value={item}
                            setInputText={(value) =>
                              onChangeTextThree(activityIndex, textIndex, value)
                            }
                          />
                        </div>

                        <div className="ms-2">
                          {activity.textThree.length > 1 && (
                            <HighlightOffIcon
                              className="cursor"
                              color="primary"
                              onClick={() =>
                                removeTextThree(activityIndex, textIndex)
                              }
                            />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <AddMorebtn
                    style={{
                      width: "100px",
                      height: "36px",
                    }}
                    handleClick={() => addTextThree(activityIndex)}
                  />
                </div>

                {/* Type */}

                <div className="d-flex align-items-center">
                  <LabelField labelName={"Type"} />

                  <div className="col-md-8">
                    <Dropdown
                      labelName="Select Type"
                      options={activityTypeList}
                      value={activity.type}
                      setInputText={(value) =>
                        onChangeActivityType(value, activityIndex)
                      }
                    />
                  </div>
                </div>
              </div>
            ))}

            {activityData.length < 10 && (
              <div className="d-flex justify-content-end">
                <AddMorebtn
                  style={{
                    width: "100px",
                    height: "36px",
                  }}
                  handleClick={handleAddActivity}
                />
              </div>
            )}
          </div>
        </div>
        <SubmitButton name="Update" validations={validations()} />
      </>
    );
  };

  const validations = () => {
    const { morningImage, morningURL, eveningImage, eveningURL } = state;
    let isValidate = false;
    if (morningImage) {
      if (morningImage && morningURL) {
        isValidate = false;
      } else {
        isValidate = true;
      }
    }
    if (eveningImage) {
      if (eveningImage && eveningURL) {
        isValidate = false;
      } else {
        isValidate = true;
      }
    }
    return isValidate;
  };

  const handleEdit = async (val) => {
    const { examList, sectionList } = state;
    updateState({ editCouponId: val?._id });
    let tempExam = examList?.find((item) => item?._id === val?.examTypeId?._id);
    updateState({ exam: tempExam });
    dispatch(
      getParentCourseNew(`${val?.examTypeId?._id}`, (res) => {
        let tempExamStream = res?.find(
          (item) => item?._id === val?.baseCourseId?._id,
        );
        updateState({ examStreamList: res, examStream: tempExamStream });
      }),
    );

    let a = sectionList;
    let b = a?.filter((item) => {
      return val?.sectionType?.includes(item?.type);
    });
    let c = b?.map((item) => {
      let obj = {
        sectionVal: item,
      };
      return obj;
    });

    let tempActivityData = val?.userActivityContent?.map((activityItem) => {
      let tempType = activityTypeList?.find(
        (t) => t?.type === activityItem?.type,
      );
      return {
        imagePreview: activityItem?.image || "",
        selectedImage: "",
        uploadedImage: activityItem?.image || "",
        textTwo:
          activityItem?.textTwo?.length > 0 ? activityItem.textTwo : [""],
        textThree:
          activityItem?.textThree?.length > 0 ? activityItem.textThree : [""],
        type: tempType || "",
      };
    });

    await updateState({
      sectionData: c,
      discount: val?.discPer,
      pdfLink: val?.link,
      messageId: val?.templateId,
      durationHr: val?.validHours,
      activityData:
        tempActivityData?.length > 0
          ? tempActivityData
          : [initialValueActivity],
    });
    if (val?.morningMessage?.image) {
      await updateState({
        morningImage: val?.morningMessage?.image,
        morningURL: val?.morningMessage?.url,
      });
    }
    if (val?.eveningMessage) {
      await updateState({
        eveningImage: val?.eveningMessage?.image,
        eveningURL: val?.eveningMessage?.url,
      });
    }

    dispatch(setParentCourse("isEditMode", true));
  };
  const handleDelete = (value) => {
    dispatch(
      deleteConfigCoupon(value?._id, () => {
        fetchData(state?.searchExamStream?._id);
      }),
    );
  };
  const fetchData = (examStreamId) => {
    const { searchExam } = state;
    let reqBody = {
      examTypeId: searchExam?._id,
      baseCourseId: examStreamId,
    };
    dispatch(
      getConfigCoupon(reqBody, (resp) => {
        if (resp?.data?.length > 0) updateState({ couponList: resp?.data });
        else updateState({ couponList: [] });
      }),
    );
  };
  const handleCancelEditMode = () => {
    dispatch(setParentCourse("isEditMode", false));
    updateState({ editCouponId: "", exam: "", examStream: "" });
  };
  const handleCloseSection = (index) => {
    const newArray = [...state?.sectionData];
    if (index > -1) {
      newArray.splice(index, 1);
    }
    updateState({ sectionData: newArray });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const {
      sectionData,
      discount,
      examStream,
      exam,
      durationHr,
      messageId,
      selectedPDF,
      uploadedPdf,
      editCouponId,
      searchExamStream,
      morningImage,
      selectedMorningImage,
      uploadedMorningImage,
      morningURL,
      eveningImage,
      selectedEveningImage,
      uploadedEveningImage,
      eveningURL,
      activityData,
    } = state;
    const newSectionArr = [];
    sectionData?.forEach((i) => {
      let section_val = i?.sectionVal?.type;
      if (!newSectionArr.includes(section_val)) {
        newSectionArr?.push(section_val);
      }
    });

    const newActivityArr = activityData
      ?.filter((item) => item?.uploadedImage || item?.imagePreview)
      ?.map((item) => ({
        image: item?.uploadedImage || item?.imagePreview,
        textTwo: item?.textTwo?.filter((t) => t?.trim() !== ""),
        textThree: item?.textThree?.filter((t) => t?.trim() !== ""),
        type: item?.type?.type,
      }));

    let reqBody = {
      discPer: discount,
      baseCourseId: examStream?._id,
      examTypeId: exam?._id,
      sectionType: newSectionArr,
      validHours: durationHr,
      templateId: messageId,
      userActivityContent: newActivityArr,
    };
    if (selectedPDF) reqBody.link = uploadedPdf;
    if (selectedMorningImage) {
      reqBody["morningMessage"] = {
        image: uploadedMorningImage,
        url: morningURL,
      };
    }
    if (selectedEveningImage) {
      reqBody["eveningMessage"] = {
        image: uploadedEveningImage,
        url: eveningURL,
      };
    }
    dispatch(
      editConfigCoupon(editCouponId, reqBody, () => {
        fetchData(searchExamStream?._id);
        updateState({
          editCouponId: "",
          exam: "",
          examStream: "",
          pdfLink: "",
          selectedPDF: "",
          sectionData: [initialValueSection],
          morningImage: "",
          selectedMorningImage: "",
          uploadedMorningImage: "",
          morningURL: "",
          eveningImage: "",
          selectedEveningImage: "",
          uploadedEveningImage: "",
          eveningURL: "",
          activityData: [initialValueActivity],
        });
        dispatch(setParentCourse("isEditMode", false));
      }),
    );
  };
  useEffect(() => {
    dispatch(
      getExamListNew((res) => {
        if (res?.length > 0) updateState({ examList: res });
        else updateState({ examList: [] });
      }),
    );
    dispatch(
      getSectionList(
        "",
        (res) => {
          if (res?.data?.length > 0) updateState({ sectionList: res?.data });
          else updateState({ sectionList: [] });
        },
        () => {},
      ),
    );
    dispatch(
      getConfigCoupon({}, (resp) => {
        if (resp?.data?.length > 0) updateState({ couponList: resp?.data });
        else updateState({ couponList: [] });
      }),
    );
  }, []);
  return (
    <div className="contentBox">
      <PageTitle
        name={"EDIT STUDENT COUPON CODE"}
        isEditMode={isEditMode}
        onClick={handleCancelEditMode}
      />
      <div className="formDiv contentScrollbar">
        <div className="col-12 formWidth">
          <form onSubmit={(e) => handleSubmit(e)}>
            {!isEditMode ? renderListMode() : renderEditMode()}
          </form>
        </div>
      </div>
    </div>
  );
};

export default StudentCouponEdit;
